import { db } from "../firebase";
import { collection, addDoc, getDocs, updateDoc, doc, query, orderBy } from "firebase/firestore";

const COL = "consultas";

export async function enviarConsulta(datos) {
  return await addDoc(collection(db, COL), {
    ...datos,
    leida: false,
    fecha: new Date(),
  });
}

export async function getConsultas() {
  const q = query(collection(db, COL), orderBy("fecha", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function marcarLeida(id) {
  return await updateDoc(doc(db, COL, id), { leida: true });
}

const consultasService = { enviarConsulta, getConsultas, marcarLeida };
export default consultasService;